// src/services/notifications/strategies/WhatsAppProviderFactory.js
import { notificationConfig } from '@/config/notification.config';
import { Chat360Provider } from './providers/Chat360Provider';
import { ZAPIProvider } from './providers/ZAPIProvider';

export class WhatsAppProviderFactory {
  // Cache de provedores já criados (para evitar criar múltiplas instâncias)
  static providerCache = new Map();
  
  static create(profileName = null) {
    console.log("WhatsAppProviderFactory: Criando provider para perfil:", profileName);
    
    // Se nenhum perfil for especificado, usar o padrão
    if (!profileName) {
      profileName = notificationConfig.defaultWhatsappProfile;
      console.log("WhatsAppProviderFactory: Usando perfil padrão:", profileName);
    }
    
    // Verificar se já temos este provider em cache
    if (this.providerCache.has(profileName)) {
      console.log("WhatsAppProviderFactory: Retornando provider do cache para:", profileName);
      return this.providerCache.get(profileName);
    }
    
    // Obter as configurações do perfil
    const profileConfig = notificationConfig.whatsappProfiles && 
                        notificationConfig.whatsappProfiles[profileName];
    
    if (!profileConfig) {
      console.error(`WhatsAppProviderFactory: Perfil ${profileName} não encontrado`);
      throw new Error(`Perfil de WhatsApp '${profileName}' não encontrado na configuração`);
    }
    
    const providerType = profileConfig.provider;
    const config = {
      ...profileConfig.config,
      senderNumber: profileConfig.senderNumber
    };
    
    console.log(`WhatsAppProviderFactory: Criando provider ${providerType} para perfil ${profileName}`);
    
    // Criar o provider adequado
    let provider;
    switch (providerType) {
      case 'chat360':
        provider = new Chat360Provider(config);
        break;
      case 'zapi':
        provider = new ZAPIProvider(config);
        break;
      default:
        console.error(`WhatsAppProviderFactory: Provider não suportado: ${providerType}`);
        throw new Error(`Provider WhatsApp não suportado: ${providerType}`);
    }
    
    // Armazenar no cache para uso futuro
    this.providerCache.set(profileName, provider);
    
    return provider;
  }
}